import {defineAsyncComponent} from 'vue';

const expenseNormRegulationWelcomePopup = defineAsyncComponent(() =>
  import('@/views/tourPopup/ExpenseNormRegulationWelcomePopup.vue'),
);

const expenseNormRedirectVoucherPopup = defineAsyncComponent(() =>
  import('@/views/tourPopup/ExpenseNormRedirectVoucherPopup.vue'),
);

export function tourPopupRegister(app) {
  app.component('ExpenseNormRegulationWelcomePopup', expenseNormRegulationWelcomePopup);
  app.component('ExpenseNormRedirectVoucherPopup', expenseNormRedirectVoucherPopup);
}
